module.exports = __webpack_public_path__ + "img/sodexo_footer.d18266b.png";